import {salaryConfigVI} from "./salaryconfig/vi";

export const WageVI = {
    ...salaryConfigVI
}